"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    Subtitle1: function() {
        return _index.Subtitle1;
    },
    subtitle1ClassNames: function() {
        return _index.subtitle1ClassNames;
    }
});
const _index = require("./components/presets/Subtitle1/index");
